// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Polygon
 */
export interface Polygon {
  /**
   *
   */
  type: PolygonTypeEnum;
  /**
   *
   */
  coordinates: Array<Array<Array<string>>>;
}

/**
 * @export
 */
export const PolygonTypeEnum = {
  Polygon: "Polygon",
} as const;
export type PolygonTypeEnum = (typeof PolygonTypeEnum)[keyof typeof PolygonTypeEnum];

/**
 * Check if a given object implements the Polygon interface.
 */
export function instanceOfPolygon(value: object): value is Polygon {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (value["type"] !== "Polygon") return false;

  if (!("coordinates" in value) || value["coordinates"] === undefined) return false;
  return true;
}

export function PolygonFromJSON(json: any): Polygon {
  return PolygonFromJSONTyped(json, false);
}

export function PolygonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Polygon {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    coordinates: json["coordinates"],
  };
}

export function PolygonToJSON(json: any): Polygon {
  return PolygonToJSONTyped(json, false);
}

export function PolygonToJSONTyped(
  value?: Polygon | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
